import { apiGet, apiPatch } from './client';
import type {
  BenchmarkRate,
  BenchmarkRateBatchRequest,
} from '../types/BenchmarkRate';

export function getBenchmarkRates(): Promise<BenchmarkRate[]> {
  return apiGet<BenchmarkRate[]>('/api/benchmark-rates');
}

export function saveBenchmarkRatesBatch(
  added: BenchmarkRate[],
  modified: BenchmarkRate[],
  deletedIds: number[],
): Promise<BenchmarkRate[]> {
  return apiPatch<BenchmarkRateBatchRequest, BenchmarkRate[]>(
    '/api/benchmark-rates/batch',
    {
      added,
      modified,
      deleted: deletedIds,
    },
  );
}
